// /**
//  * Parcel - Edit
//  */

// React
import React, {useState, useContext, useEffect} from 'react';
// Context
import AuthContext from '../../../../authContext';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// UI
import theme from '../../../../theme';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
  Card,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import AddItemsParcelsList from './editItemsParcelsList';
import AddItemsParcelsForm from './editItemsParcelsForm';
import AddInventoryItemsParcelsForm from './editInventoryItemsParcelsForm';
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiPlus,
  mdiPackageVariantClosed,
  mdiCalendar,
  mdiArrowRight,
  mdiCalendarClock,
  mdiFormatListCheckbox,
  mdiWarehouse,
  mdiAccountOutline,
  mdiClose,
  mdiArchiveOutline,
  mdiCheck,
  mdiCubeSend,
  mdiCubeOutline,
  mdiCounter,
  mdiTableRowHeight,
  mdiTableColumnWidth,
  mdiRuler,
  mdiPlusCircle,
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllWarehousesRequestBuilder} from 'client-sdk/src/warehouses/warehouses';

// Type
import {Parcel, ParcelItems} from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
  PayloadUpdate,
} from '../../../parcels/interfaces';
import {Warehouse} from '../../../warehouses/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
} from '../../../../utils/helpers';
import {Product} from '../../../products/interfaces';
import {Variant} from '../../../products/interfaces';
import {
  getParcelsWithIdAction,
  updateParcelsActions,
  deleteParcelItemsActions,
  createParcelItemsActions,
} from '../../../parcels/actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../../redux/reducers';
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
  makeSelectParcel,
} from '../../../parcels/selectors';

import {useHistory} from 'react-router-dom';
import moment from 'moment';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  create: (body: any) => void;
  match: {
    params: {
      id: number;
    };
  };
  parcel: Parcel;
  onClose: () => void;
  warehouseId: number;
  updateParcelsDispatch: (payload: PayloadUpdate) => void;
  getParcelWithIdActionDispatch: (id: number) => void;
  deleteItemDispatch: (payload: Object) => void;
  createItemDispatch: (payload: Object) => void;
};

interface SelectorProps {
  parcelsList: Parcel[];
  parcel: Parcel;
  count: number;
  loading: boolean;
  error: any;
}

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryTime: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      marginLeft: '20px',
      marginRight: '20px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      marginTop: '0',
      textAlign: 'center',
      // paddingTop: theme.spacing(2),
      // paddingRight: theme.spacing(3),
      // paddingLeft: theme.spacing(3),
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '-3px',
      overflow: 'visible',
      padding: '14px',
      paddingBottom: '0',
      width: '100%',
    },
  })
);

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

function Edit(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const {register, handleSubmit, control, errors, watch, setValue, getValues} =
    useForm<Inputs>({
      defaultValues: {
        deliveryType: '',
        deliveryTime: '',
        deliveryDate: null,
        pickDate: null,
        pickTime: null,
        deliveryStartTime: null,
        deliveryEndTime: null,
      },
    });

  let lat: any = 35.6892;
  let lon: any = 51.389;
  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('');
  const [transportationType, setTransportationType] = useState<any>('');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] =
    React.useState(false);
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [inventoryItems, setInventoryItems] = useState<any>([]);
  const [inventoryItem, setInventoryItem] = useState<any>({});
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [clearSelected, setClearSelected] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [destinationId, setDestinationId] = useState(0 as number);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [dimensions, setDimensions] = useState<any>([]);
  const [boxCount, setBoxCount] = useState('');
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [count, setCount] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const loading = openAutocomplete && options.length === 0;
  const [latLng, setLatLng] = useState({lat: 0, lng: 0} as {
    lat: number;
    lng: number;
  });

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height,
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setLength('');
    setHeight('');
    setWidth('');
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);

  const checkButtonDisabled = () => {
    const fields = [count, length, width, height];
    return fields.some(field => !field) && totalBoxCount < Number(boxCount);
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    setDimensions([]);
  };

  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO;
    const {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      deliveryTime,
      deliveryStartTime,
      deliveryEndTime,
      pickAddress,
      pickDate,
      pickTime,
    } = data;

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate,
      pickTime: pickTime?.substr(10),
    };

    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
    }

    addParcel({
      agentName,
      agentPhoneNumber,
      deliveryType,
      sellerId: authContext?.user?.sellerIds,
      id: props.match.params.id,
      deliveryDate,
      transportationType,
      ronadTransportationDTO,
      deliveryStartTime: convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(':00:00')
      ),
      deliveryEndTime: convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(':00:00')
      ),
      destinationId,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
    });
  };

  const addParcel = (body: any) => {
    setParcelsData(body);
    handleOpenCheckConfirm();
  };

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    const categoryName = category?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);
    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    if (hasExpirationDate) {
      setOpenAddInventoryItem(true);
    } else {
      setItems([
        ...items,
        {
          variantId,
          productId: idItem,
          count,
          packageCount: boxCount ?? 1,
          packageAmount: countOfBox ?? Number(count),
          inventoryItems: [
            {
              amount: Number(count),
              unitCost: unitCost ?? 0,
              productionDate: null,
              expirationDate: null,
            },
          ],
        },
      ]);
      setOpenAddItem(false);
    }
  };

  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setInventoryItems(body);
    setInventoryItem({...item, inventoryItems: body});
    setItems([...items, {...item, inventoryItems: body}]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true);
    setItemDeleted(body);
  };

  const handleOpenCheckConfirm = () => {
    setCheckSubmit(true);
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
    setCheckSubmit(false);
  };

  const handleChangeDeliverType = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setDeliveryType(event.target.value as string);
  };

  const deleteItem = () => {
    const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

  const deleteItemsToParcels = () => {
    props.deleteItemDispatch({
      id: itemDeleted.id,
      callback: () => deleteItem(),
    });
  };

  useEffect(() => {
    const {id} = props.match.params;
    props.getParcelWithIdActionDispatch(id);
    setOpenAutocomplete(false);
  }, []);

  useEffect(() => {
    if (props.parcel.id) {
      setValue('agentName', props.parcel.agentName);
      setValue('agentPhoneNumber', props.parcel.agentPhoneNumber);
      setValue('deliveryDate', props.parcel.deliveryDate);
      setValue('pickDate', props.parcel.ronadTransportationDTO?.pickDate);
      setValue(
        'pickTime',
        props.parcel.ronadTransportationDTO?.pickDate.concat(
          ' ',
          props.parcel.ronadTransportationDTO?.pickTime
        )
      );
      setValue(
        'deliveryStartTime',
        props.parcel.deliveryDate.concat(' ', props.parcel.deliveryStartTime)
      );
      setValue(
        'deliveryEndTime',
        props.parcel.deliveryDate.concat(' ', props.parcel.deliveryEndTime)
      );
      setValue(
        'deliveryTime',
        props.parcel.deliveryStartTime === '09:00:00'
          ? '09-11'
          : props.parcel.deliveryStartTime === '11:00:00'
          ? '11-13'
          : props.parcel.deliveryStartTime === '14:00:00'
          ? '14-16'
          : ''
      );
      setLatLng({
        lat: props.parcel.ronadTransportationDTO?.lat ?? 0,
        lng: props.parcel.ronadTransportationDTO?.lon ?? 0,
      });
      const parcelItems = props.parcel.items.map((item: any) => {
        let variantName = item.productName;
        for (let i = 0; i <= 2 && item.featureAndValues[i]; i++) {
          variantName = variantName.concat(
            ' - ',
            item.featureAndValues[i].key,
            ' : ',
            item.featureAndValues[i].value
          );
        }

        if (item.sellerName || item.providerName) {
          const sellerName = item.sellerName ?? item.providerName;
          variantName = variantName.concat(' ( ', sellerName, ' )');
        }
        return {
          id: item.id,
          skuId: item.skuId,
          productId: item.skuId,
          count: item.count,
          name: variantName,
          boxCount: item.boxCount,
          countOfBox: item.boxType,
          product: {name: item.productName, code: item.productCode},
          variant: {
            code: item.variantCode,
            features: item.featureAndValues,
            sellerName: item.sellerName,
            providerName: item.providerName,
          },
        };
      });
      setItemsInfo(parcelItems);
      setDeliveryType(props.parcel.deliveryType);
      setTransportationType(props.parcel.transportationType);
    }
  }, [props.parcel]);

  useEffect(() => {
    setValue('pickAddress', props.parcel.ronadTransportationDTO?.pickAddress);
  }, [transportationType]);

  useEffect(() => {
    if (props.parcel.id && openAutocomplete && options.length) {
      const currentWarehouse = options.length
        ? options.filter(option => option.id === props.parcel.destinationId)[0]
        : null;
      if (!destinationId && !clearSelected) {
        setValueWarehouse(currentWarehouse);
        setDestinationId(props.parcel.destinationId);
      }
    }
  }, [props.parcel, openAutocomplete, options]);

  useEffect(() => {
    if (destinationId) setOpenAutocomplete(false);
  }, [destinationId]);

  useEffect(() => {
    const {id} = props.match.params;
    if (inventoryItem.variantId)
      props.createItemDispatch({
        body: inventoryItem,
        id,
        callback: () => {
          props.getParcelWithIdActionDispatch(id);
        },
      });
  }, [inventoryItem]);

  const handleCreateParcel = () => {
    const parcelData = {...parcelsData};
    props.updateParcelsDispatch({
      body: parcelData,
      pagination: {
        page: 0,
        size: 10,
        sellerId: {equals: authContext.user?.sellerIds},
      },
      callback: () => {
        setParcelsData({});
        history.push('/seller-parcels');
      },
    });
    handleCloseDimensions();
    setCheckSubmit(false);
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('deliveryTime', '');
  };

  const handlePickDateChange = (date: any) => {
    setValue(
      'pickDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const handlePickTimeChange = (date: any) => {
    setValue(
      'pickTime',
      convertPersianDigit2English(date.format('YYYY-MM-DD HH:mm:ss'))
    );
  };

  useOnMount(() => {
    register(
      {name: 'deliveryDate', type: 'text'},
      {validate: required('تاریخ تحویل را وارد کنید')}
    );
    register({name: 'pickDate', type: 'text', defaultValue: ''});
    register({name: 'pickTime', type: 'text', defaultValue: ''});
  });

  const values = getValues();

  return (
    <>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
         ویرایش محموله  
         `}
              <span> &nbsp; {props.match.params.id}</span>
            </Typography>
          </div>
        </Paper>
      </Grid>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          lg={12}
          md={12}
          container
          style={{marginTop: '-15px'}}
          spacing={4}
        >
          <Grid container item md={12} xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    اطلاعات محموله
                  </Typography>
                }
              />
              <CardContent>
                <Grid container xs={12} sm={12} lg={12} spacing={2}>
                  <Grid container xs={9} sm={9} lg={9} spacing={2}>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <span style={{width: '100%'}}>
                          <MuiPickersUtilsProvider
                            utils={JalaliUtils}
                            locale="fa"
                          >
                            <DatePicker
                              inputVariant="outlined"
                              id="deliveryDate"
                              name="deliveryDate"
                              label="تاریخ تحویل محموله"
                              format="jYYYY/jMM/jDD"
                              disablePast
                              disableToolbar
                              fullWidth
                              okLabel="تأیید"
                              cancelLabel="لغو"
                              defaultValue={null}
                              value={values.deliveryDate}
                              onChange={handleDeliveryDateChange}
                              error={errors.hasOwnProperty('deliveryDate')}
                              helperText={
                                errors.deliveryDate &&
                                errors.deliveryDate.message
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <span
                          style={{
                            width: '100%',
                          }}
                        >
                          <Controller
                            rules={{required: true}}
                            style={{width: '100%'}}
                            control={control}
                            name="deliveryTime"
                            label="بازه تحویل محموله"
                            as={
                              <TextField
                                variant="outlined"
                                select
                                fullWidth
                                error={
                                  !!errors.deliveryTime && !!errors.deliveryTime
                                }
                              >
                                <MenuItem
                                  disabled={checkHourisPast(
                                    9,
                                    values.deliveryDate
                                  )}
                                  value={'09-11'}
                                >
                                  {'9 الی 11'}
                                </MenuItem>
                                <MenuItem
                                  disabled={checkHourisPast(
                                    11,
                                    values.deliveryDate
                                  )}
                                  value={'11-13'}
                                >
                                  {'11 الی 13'}
                                </MenuItem>
                                <MenuItem
                                  disabled={checkHourisPast(
                                    14,
                                    values.deliveryDate
                                  )}
                                  value={'14-16'}
                                >
                                  {'14 الی 16'}
                                </MenuItem>
                              </TextField>
                            }
                          />
                          <FormHelperText error focused>
                            {errors?.deliveryTime &&
                              ' بازه تحویل محموله الزامی میباشد'}
                          </FormHelperText>
                        </span>
                      </div>
                    </Grid>

                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      <div className={classes.item}>
                        <span style={{width: '100%'}}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="transportationTypeLabel">
                              نوع ارسال
                            </InputLabel>
                            <Select
                              label="نوع ارسال"
                              fullWidth
                              id="transportationType"
                              name="transportationType"
                              inputProps={{
                                name: 'transportationType',
                                id: 'transportationType',
                              }}
                              labelId="transportationTypeLabel"
                              value={transportationType}
                              onChange={e =>
                                setTransportationType(e.target.value)
                              }
                              inputRef={register({required: true})}
                            >
                              <MenuItem value={'PARTNER'}>
                                ارسال توسط خودم
                              </MenuItem>
                              <MenuItem value={'RONAD'}>
                                ارسال توسط روناد
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </span>
                      </div>
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      {transportationType === 'RONAD' ? (
                        <div className={classes.item}>
                          <span style={{width: '100%'}}>
                            <MuiPickersUtilsProvider
                              utils={JalaliUtils}
                              locale="fa"
                            >
                              <DatePicker
                                inputVariant="outlined"
                                id="pickDate"
                                name="pickDate"
                                label="تاریخ تحویل به ناوگان"
                                format="jYYYY/jMM/jDD"
                                disablePast
                                disableToolbar
                                fullWidth
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                defaultValue={null}
                                value={values.pickDate}
                                onChange={handlePickDateChange}
                                error={errors.hasOwnProperty('pickDate')}
                                helperText={
                                  errors.pickDate && errors.pickDate.message
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </span>
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item xs={4} sm={4} lg={4} spacing={2}>
                      {transportationType === 'RONAD' ? (
                        <div className={classes.item}>
                          <span style={{width: '100%'}}>
                            <MuiPickersUtilsProvider
                              utils={JalaliUtils}
                              locale="fa"
                            >
                              <TimePicker
                                inputVariant="outlined"
                                id="pickTime"
                                name="pickTime"
                                label="زمان تحویل به ناوگان"
                                ampm={false}
                                fullWidth
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                value={values.pickTime}
                                onChange={handlePickTimeChange}
                                error={errors.hasOwnProperty('pickTime')}
                                helperText={
                                  errors.pickTime && errors.pickTime.message
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </span>
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      {transportationType === 'RONAD' ? (
                        <Grid container item xs={12} alignItems="flex-end">
                          <div className={classes.item}>
                            <div style={{width: '100%'}}>
                              <TextField
                                variant="outlined"
                                fullWidth
                                name="pickAddress"
                                id="pickAddress"
                                label="آدرس جمع آوری"
                                InputLabelProps={{
                                  shrink:
                                    !!props.parcel.ronadTransportationDTO
                                      ?.pickAddress || !!values.pickAddress,
                                }}
                                inputRef={register({required: false})}
                                error={errors.pickAddress && true}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    xs={3}
                    sm={3}
                    lg={3}
                    style={{padding: '0 10px'}}
                  >
                    {transportationType === 'RONAD' ? (
                      <Grid item xs={12}>
                        <MapPosition
                          style={{
                            // marginBottom: '20px',
                            height: '250px',
                            zIndex: 1,
                            border: 'solid 2px gray',
                            borderRadius: '4px',
                          }}
                          zoom={14}
                          center={{lat: 35.6892, lng: 51.389}}
                          position={latLng}
                          setLatlng={(latLng: {lat: number; lng: number}) => {
                            setLatLng(latLng);
                          }}
                        />
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container lg={12} md={12} spacing={4}>
          <Grid container item md={12} xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    اطلاعات انبار مقصد
                  </Typography>
                }
              />
              <CardContent>
                <Grid container item spacing={2}>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <Autocomplete
                        fullWidth
                        open={openAutocomplete}
                        onOpen={() => {
                          setOpenAutocomplete(true);
                        }}
                        onClose={() => {
                          setOpenAutocomplete(false);
                        }}
                        getOptionSelected={(option, value) =>
                          option.name === value?.name
                        }
                        value={valueWarehouse}
                        getOptionLabel={option => option.name}
                        options={options}
                        loading={loading}
                        onChange={(
                          event: any,
                          newValue: any | null,
                          reason
                        ) => {
                          setDestinationId(newValue?.id);
                          setValueWarehouse(newValue);
                          if (reason === 'clear') {
                            setClearSelected(true);
                          }
                        }}
                        renderInput={params => (
                          <TextField
                            variant="outlined"
                            {...params}
                            label="مقصد"
                            inputRef={register({required: false})}
                            className={classes.textInput}
                            InputLabelProps={{
                              shrink:
                                !!props.parcel.destinationId ||
                                !!values.destinationId,
                            }}
                            name="admin"
                            id="admin"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {loading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={20}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={9} sm={9} lg={9} spacing={2}>
                    <div className={classes.item}>
                      {valueWarehouse ? (
                        <TextField
                          variant="outlined"
                          fullWidth
                          value={valueWarehouse?.address}
                          label="آدرس انبار"
                          inputProps={{readOnly: true}}
                        />
                      ) : (
                        <TextField
                          variant="outlined"
                          fullWidth
                          value={''}
                          label="آدرس انبار"
                          inputProps={{readOnly: true}}
                        />
                      )}
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container lg={12} md={12} spacing={4}>
          <Grid container item md={12} xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    اطلاعات مسئول حمل
                  </Typography>
                }
              />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="agentName"
                        name="agentName"
                        InputLabelProps={{
                          shrink:
                            !!props.parcel.agentName || !!values.agentName,
                        }}
                        label="نام  "
                        inputRef={register({required: true})}
                        error={errors.agentName && true}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={3} sm={3} lg={3} spacing={2}>
                    <div className={classes.item}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="agentPhoneNumber"
                        name="agentPhoneNumber"
                        label="شماره همراه (۰۹۱۲۳۴۵۶۷۸۹)"
                        InputLabelProps={{
                          shrink:
                            !!props.parcel.agentPhoneNumber ||
                            !!values.agentPhoneNumber,
                        }}
                        inputRef={register({required: true})}
                      />
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          lg={12}
          md={12}
          spacing={4}
          style={{paddingBottom: '60px'}}
        >
          <Grid container item md={12} xs={12} style={{marginBottom: '150px'}}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Typography className={classes.typographyCards}>
                    کالاهای محموله
                  </Typography>
                }
                action={
                  <Button
                    style={{marginTop: '10px'}}
                    variant="outlined"
                    color="primary"
                    size="medium"
                    startIcon={<Icon path={mdiPlusCircle} size={'17px'} />}
                    onClick={() => {
                      setOpenAddItem(true);
                    }}
                  >
                    {'افزودن کالا به محموله'}
                  </Button>
                }
              />
              <CardContent style={{margin: '14px 0  0', padding: '0 0 12px 0'}}>
                <Grid container spacing={3}>
                  {itemsInfo.length > 0 && (
                    <AddItemsParcelsList
                      data={itemsInfo}
                      deleteItem={(body: any) => setConfirmDelete(body)}
                    />
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '75px',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '35px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
              }}
            >
              {'انصراف'}
            </Button>
            <Button
              type="submit"
              size="medium"
              data-cy="search"
              autoFocus
              variant="contained"
              color="primary"
              disabled={
                Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                  .length === 0
              }
              style={{
                marginRight: '14px',
                marginLeft: '120px',
              }}
            >
              {'ذخیره تغییرات '}
            </Button>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={openConfirmDelete}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div>
          <Divider style={{width: '100%', margin: '16px 0  0'}} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{textAlign: 'center', marginBottom: '8px'}}
          >
            <Grid item xs={12}>
              <Button
                style={{margin: '8px'}}
                autoFocus
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
                color="primary"
              >
                {'حذف کالا'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose && (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            )}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ویرایش محموله با انبار "${
              checkSubmit ? valueWarehouse?.name : ''
            }" مطمئنید؟`}
          </div>
          <Divider style={{width: '100%', margin: '16px 0  0'}} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{textAlign: 'center', marginBottom: '8px'}}
          >
            <Grid item xs={12}>
              <Button
                style={{marginLeft: '8px'}}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose && (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            )}
          </div>

          <div className={classes.cancelTitle}>
            {`ایا از ویرایش محموله با انبار "${
              checkSubmit ? valueWarehouse?.name : ''
            }" مطمئنید؟`}
          </div>
          <Divider style={{width: '100%', margin: '16px 0  0'}} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{textAlign: 'center', marginBottom: '8px'}}
          >
            <Grid item xs={12}>
              <Button
                style={{marginLeft: '8px'}}
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="outlined"
                color="primary"
                size="large"
              >
                {'انصراف'}
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          {boxCount && openListDimensions ? (
            <Grid container alignItems="center" spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiCounter} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableRowHeight} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="length"
                    name="length"
                    value={length}
                    onChange={e => setLength(e.target.value)}
                    label="طول"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableColumnWidth} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="width"
                    name="width"
                    value={width}
                    onChange={e => setWidth(e.target.value)}
                    label="عرض"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiRuler} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="height"
                    name="height"
                    value={height}
                    onChange={e => setHeight(e.target.value)}
                    label="ارتفاع"
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12}>
                <p>{'تعداد بسته‌بندی های محموله را وارد کنید'}</p>
              </Grid>
              <Grid item xs={1}>
                <Icon path={mdiCounter} size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id="boxCount"
                  name="boxCount"
                  value={boxCount}
                  onChange={e => setBoxCount(e.target.value)}
                  label="تعداد بسته"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant="contained"
                  color="secondary"
                  disabled={checkButtonDisabled()}
                  size="large"
                >
                  {totalBoxCount >= Number(boxCount)
                    ? 'مرحله بعد'
                    : 'اضافه کردن بسته'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleClose()}
                  size="large"
                >
                  {'بازگشت'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant="contained"
                  color="secondary"
                  disabled={!boxCount}
                  size="large"
                >
                  {'مرحله بعد'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleCloseDimensions()}
                  size="large"
                >
                  {'بستن'}
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <Typography
            variant="h6"
            style={{textAlign: 'center', marginTop: '20px'}}
          >
            افزودن کالا به محموله
          </Typography>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcel: makeSelectParcel(),
  parcelsList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({id})),
    updateParcelsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateParcelsActions(payload)),
    deleteItemDispatch: (payload: Object) =>
      dispatch(deleteParcelItemsActions(payload)),
    createItemDispatch: (payload: Object) =>
      dispatch(createParcelItemsActions(payload)),
  };
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Edit);
